import { LinkButton, Text } from '@outdoorsyco/bonfire';
import Link from 'next/link';
import { FormattedMessage, useIntl } from 'react-intl';

type TAddAboutMeProps = {
  userId: number;
};

export const AddAboutMe = ({ userId }: TAddAboutMeProps) => {
  const intl = useIntl();

  return (
    <div className="flex flex-col items-center justify-between p-6 text-center gap-4 bg-[#F1F2F3] rounded-2xl">
      <Text className="text-secondary-base">
        <FormattedMessage
          defaultMessage="You haven’t added an “about me” yet. Share a little about yourself to personalize your profile."
          id="3avruM"
        />
      </Text>
      <Link href={`/account/${userId}/edit?zone=AboutMe`} passHref legacyBehavior>
        <LinkButton
          label={intl.formatMessage({
            defaultMessage: 'Add about me',
            id: 'mLAafN',
          })}
        />
      </Link>
    </div>
  );
};
